import isUndefined from 'lodash/isUndefined';
import React, { useEffect, useState } from 'react';

export function useComponentsLoader(_components) {
  const [components, setComponents] = useState([]);

  useEffect(() => {
    const importComponent = async (componentId) => {
      const { default: Component } = await import(
        /* webpackChunkName: "[request]" */
        `../components/backoffice/${componentId}/${componentId}`
      );
      return Component;
    };

    const loadComponent = async (component, i) => {
      const Component = await importComponent(component.id);
      let valuesObj = [];
      let nestedComponents = [];
      if (!component?.nestedComponents) {
        return (
          <Component
            key={component.id + i + component?.attribute}
            {...component}
          />
        );
      } else {
        if (
          component.nestedComponents &&
          isUndefined(component?.isNotNestedType)
        ) {
          nestedComponents = await Promise.all(
            component.nestedComponents.map(loadComponent)
          );
        } else if (
          component?.nestedComponents?.length > 0 &&
          component?.isNotNestedType &&
          component?.id === 'RXC_CUSTOM_TOGGLE'
        ) {
          valuesObj = await Promise.all(
            component?.nestedComponents?.map(async (comp: any) => ({
              ...comp,
              nestedComponents: await Promise.all(
                comp.nestedComponents?.map(loadComponent)
              ),
            }))
          );
        }
        return (
          <Component
            key={component.id + i + component?.attribute}
            {...component}
            nestedComponents={nestedComponents ?? nestedComponents}
            values={valuesObj ?? valuesObj}
          ></Component>
        );
      }
    };

    const loadComponents = async () => {
      const loadedComponents = await Promise.all(
        _components.map(loadComponent)
      );
      setComponents(loadedComponents);
    };

    if (_components && _components?.length) loadComponents();
  }, [_components]);
  return components;
}
